import { type FC } from "react";

import { ButtonDisabledTooltip } from "../../shared/components/ButtonDisabledTooltip";

import { GenerateCTA, HostedLensPageDisabledButton } from "./messages.generated";

interface GenerateHostedLensButtonProps {
    onClick: () => void;
    isDisabled: boolean;
}

export const GenerateHostedLensButton: FC<GenerateHostedLensButtonProps> = ({ onClick, isDisabled }) => (
    <ButtonDisabledTooltip
        tooltip={{
            content: <HostedLensPageDisabledButton />,
            placement: "bottom",
        }}
        isDisabled={isDisabled}
        type="primary"
        onClick={onClick}
    >
        <GenerateCTA />
    </ButtonDisabledTooltip>
);
